import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getMasterDataApi, importMasterDataApi } from '@/api/selfAnalysis';
import { buildMpptRows } from './mpptGrid';
var TABLE = 'mppt_string_map';

/**
 * 05 一列一列填太累：先給 INV 台數 × MPPT 數 × 每個 MPPT 幾串，一次長出所有格子，
 * 再點掉空接的位置，整批走 `/import` 寫入（已存在的位置略過）。
 */
export default {
  name: 'MpptQuickBuild',
  props: {
    /** v-model：modal 開關 */
    value: {
      type: Boolean,
      default: false
    },
    siteCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      invCount: 1,
      mpptCount: 6,
      perMppt: 2,
      /** 按下「產生列表」當下的數字；之後改輸入框不會讓已點好的空接錯位 */
      built: null,
      /** 鍵是 `INV索引/串列索引`，true = 空接 */
      dead: {},
      existing: 0,
      saving: false,
      error: ''
    };
  },
  computed: {
    valid: function valid() {
      var ok = function ok(n, max) {
        return Number.isInteger(n) && n >= 1 && n <= max;
      };
      return ok(this.invCount, 200) && ok(this.mpptCount, 20) && ok(this.perMppt, 10);
    },
    slotCount: function slotCount() {
      return this.built ? this.built.mpptCount * this.built.perMppt : 0;
    },
    rows: function rows() {
      if (!this.built) return [];
      var _this$built = this.built,
        invCount = _this$built.invCount,
        mpptCount = _this$built.mpptCount,
        perMppt = _this$built.perMppt;
      return buildMpptRows(this.siteCode, invCount, mpptCount, perMppt, this.dead);
    },
    liveCount: function liveCount() {
      return this.rows.filter(function (r) {
        return r.string_id;
      }).length;
    }
  },
  methods: {
    onShow: function onShow() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.built = null;
                _this.dead = {};
                _this.error = '';
                _this.existing = 0;
                _context.prev = 4;
                _context.next = 7;
                return getMasterDataApi(TABLE, _this.siteCode);
              case 7:
                res = _context.sent;
                _this.existing = (res.data || []).length;
                _context.next = 13;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11]]);
      }))();
    },
    build: function build() {
      this.built = {
        invCount: this.invCount,
        mpptCount: this.mpptCount,
        perMppt: this.perMppt
      };
      this.dead = {};
    },
    idOf: function idOf(inv, idx) {
      var perMppt = this.built.perMppt;
      return "INV".concat(inv + 1, "-").concat(Math.floor(idx / perMppt) + 1, "-").concat(idx % perMppt + 1);
    },
    /** 一次設一批：全部已經是空接就改回有接，否則全部設成空接 */setMany: function setMany(keys) {
      var _this2 = this;
      var allDead = keys.every(function (k) {
        return _this2.dead[k];
      });
      var next = _objectSpread({}, this.dead);
      var _iterator = _createForOfIteratorHelper(keys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var k = _step.value;
          if (allDead) delete next[k];else next[k] = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.dead = next;
    },
    toggle: function toggle(inv, idx) {
      this.setMany(["".concat(inv, "/").concat(idx)]);
    },
    toggleColumn: function toggleColumn(idx) {
      this.setMany(_toConsumableArray(Array(this.built.invCount).keys()).map(function (inv) {
        return "".concat(inv, "/").concat(idx);
      }));
    },
    toggleInv: function toggleInv(inv) {
      this.setMany(_toConsumableArray(Array(this.slotCount).keys()).map(function (idx) {
        return "".concat(inv, "/").concat(idx);
      }));
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.saving = true;
                _this3.error = '';
                _context2.prev = 2;
                _context2.next = 5;
                return importMasterDataApi(TABLE, _this3.rows);
              case 5:
                res = _context2.sent;
                _this3.$swal(res.msg || '已寫入');
                _this3.$emit('input', false);
                _this3.$emit('imported');
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                _this3.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '寫入失敗';
              case 14:
                _context2.prev = 14;
                _this3.saving = false;
                return _context2.finish(14);
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11, 14, 17]]);
      }))();
    }
  }
};